/**
 * @file ui/src/main.tsx
 * @copyright 2026 Seth Zhai. BSL 1.1
 */

import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './styles/globals.css'
import './i18n'          // i18next 初始化，必须在 App 之前 import
import App from './App'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
)
